export class CartaoCreditoAuxiliarModel {
    numeroCartao: string;
    validade: string;
    ccv: string;
    nome: string;
    cpf: string;
  }